module.exports = __webpack_public_path__ + "static/glimmer_bg-6861f939fc3f0be23821fbfdb523fcc2.svg";